module.exports = __webpack_public_path__ + "../static/img/base_ros_2800.55ea4415.png";